import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import TableDesign from "../../../../components/common/table/TableDesign";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import FormField from "../../../../components/common/FormField";
import { FC } from "react";
import { DeleteOutlined } from "@mui/icons-material";

const RenderEstimateTable: FC<any> = ({
  estimateForm,
  onChangeAction,
  handleDeleteServiceRow,
  vehiclesOptions,
  onBlurAction,
  error,
  tableHeadding,
  tableContent,
  fields,
  additionRow = "",
  section = "",
  disabled = false,
  screenType,
  hideExtraServiceDelete,
}) => {
  const { leadDetails } = useSelector((state: any) => state.lead);

  const { userProfile } = useSelector((state: any) => state?.user);
  const getServiceTypeKey = (service: any) =>
    String(service?.type || service?.service_name || service?.typeName || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[,_-]+/g, "");

  const getBaseServiceTypeKey = (serviceType: string) =>
    String(serviceType || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[,_-]+/g, "")
      .replace(/_primary\d*$/, "");

  const getServiceNameKey = (service: any) =>
    String(
      service?.typeName || service?.name || service?.service_name || service?.type || "",
    )
      .toLowerCase()
      .replace(/[,_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const isRemovalRow = (service: any) =>
    getBaseServiceTypeKey(service?.type || service?.typeName || "") ===
      "removal" ||
    getServiceNameKey(service) === "removal" ||
    getServiceNameKey(service) === "removal door to door" ||
    getServiceNameKey(service) === "removal, door to door";

  const isFullPackRow = (service: any) => {
    const typeKey = getBaseServiceTypeKey(
      service?.type || service?.typeName || service?.service_name || "",
    );
    const nameKey = getServiceNameKey(service);

    return (
      typeKey === "fullpack" ||
      typeKey === "fullpacking" ||
      nameKey === "fullpack" ||
      nameKey === "fullpacking"
    );
  };

  const hasFullPack = tableContent?.some(
    (item: any) =>
      item?.type?.toLowerCase()?.replace(/\s+/g, "") === "fullpack",
  );

  const spacerIndex = hasFullPack ? 2 : 1;

  return (
    tableContent &&
    tableContent.length && (
      <TableDesign
        tableHeadings={tableHeadding}
        cellColor={"#637381"}
        fontWeight={400}
        // pagination={pagination}
        filterOption={null}
        setFilterOption={() => {}}
        extraClass="estimateTable"
      >
        <>
          {tableContent.length > 0
            ? tableContent.map((row: any, idx: number) => (
                <>
                  {section === "services" && idx === spacerIndex && (
                    <TableRow sx={{ height: "28px" }}>&nbsp;</TableRow>
                  )}
                  <TableRow key={`${section}-${idx}`}>
                    {fields &&
                      fields.length &&
                      fields.map((field: any, fieldIdx: number) => {
                        return (
                          <TableCell
                            sx={{
                              width:
                                fieldIdx === 0
                                  ? "132px"
                                  : row?.name === "Packing Materials"
                                    ? screenType === "quotation"
                                      ? "164px"
                                      : "318px"
                                    : field?.width || "auto",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {field?.type === "staticText" ? (
                              field?.id === "provisionalDate" &&
                              isFullPackRow(row) ? (
                                leadDetails?.lead?.packing_on_date ? (
                                  dayjs(
                                    leadDetails?.lead?.packing_on_date,
                                  ).format(
                                    userProfile?.dateFormat ?? "DD/MM/YYYY",
                                  )
                                ) : (
                                  <Typography
                                    style={{
                                      fontSize: "10px",
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                  >
                                    N/A
                                  </Typography>
                                )
                              ) : idx === 0 &&
                                field?.id === "provisionalDate" ? (
                                leadDetails?.lead?.moving_on_date ? (
                                  `${dayjs(
                                    leadDetails?.lead?.moving_on_date,
                                  ).format(
                                    userProfile?.dateFormat ?? "DD/MM/YYYY",
                                  )}${
                                    leadDetails?.lead?.moving_on_end_date
                                      ? " - " +
                                        dayjs(
                                          leadDetails?.lead?.moving_on_end_date,
                                        ).format(
                                          userProfile?.dateFormat ??
                                            "DD/MM/YYYY",
                                        )
                                      : ""
                                  }`
                                ) : (
                                  <Typography
                                    style={{
                                      fontSize: "10px",
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                  >
                                    N/A
                                  </Typography>
                                )
                              ) : (
                                // idx === 2 && field?.id === 'provisionalDate' ?
                                //   leadDetails?.lead?.moving_on_date && dayjs(leadDetails?.lead?.moving_on_date).format(userProfile?.dateFormat ?? "DD/MM/YYYY") :
                                <span
                                  style={{
                                    ...(function () {
                                      const serviceTypeKey =
                                        getServiceTypeKey(row);
                                      return {
                                        color:
                                          idx >= 0 &&
                                          section === "services" &&
                                          (row?.is_accepted ||
                                            row?.isAccepted) &&
                                          serviceTypeKey !== "removal"
                                            ? "#02906F"
                                            : "inherit",
                                        fontWeight:
                                          idx >= 0 &&
                                          section === "services" &&
                                          (row?.is_accepted ||
                                            row?.isAccepted) &&
                                          serviceTypeKey !== "removal"
                                            ? 600
                                            : "none",
                                      };
                                    })(),
                                  }}
                                >
                                  {row[field?.id]}
                                  {/* {formatText(row[field?.id] || "")} */}
                                  {getServiceTypeKey(row) === "removal" && (
                                    <span style={{ color: "#D32F2F" }}>*</span>
                                  )}
                                </span>
                              )
                            ) : idx >= 0 &&
                              idx <= 1 &&
                              field?.id === "name" &&
                              section === "ancillaries" ? (
                              row[field?.id]
                            ) : field?.type === "checkbox" ? (
                              <Checkbox
                                sx={{ marginTop: "16px", marginLeft: "16px" }}
                                disabled={disabled}
                                checked={
                                  estimateForm
                                    ? section &&
                                      estimateForm[section] &&
                                      estimateForm[section][idx]
                                      ? estimateForm[section][idx][field.id]
                                      : estimateForm[field.id]
                                    : ""
                                }
                                onChange={(e: any) =>
                                  onChangeAction(
                                    e,
                                    section,
                                    section === "generalInfo" ? 0 : idx,
                                    field?.valueFormat,
                                  )
                                }
                                name={field?.id}
                                id={field?.id}
                                color="primary"
                              />
                            ) : (
                              <FormField
                                // key={field.id}
                                onPaste={(e: any) =>
                                  field?.id === "description"
                                    ? ""
                                    : e.preventDefault()
                                }
                                onKeyDown={(event: any) => {
                                  console.log(
                                    "event log-",
                                    event,
                                    event.target.value + event.key,
                                  );
                                  if (
                                    event.keyCode === 8 ||
                                    event.keyCode === 9 ||
                                    event.keyCode === 37 ||
                                    event.keyCode === 38 ||
                                    event.keyCode === 39 ||
                                    event.keyCode === 40 ||
                                    event.keyCode === 18 ||
                                    event.keyCode === 17 ||
                                    event.ctrlKey
                                  )
                                    return event;
                                  if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(event.key)
                                  ) {
                                    event.preventDefault();
                                  } else if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(
                                      event.target.value + event.key,
                                    )
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                {...{
                                  ...field,
                                  id:
                                    section === "generalInfo"
                                      ? field?.id
                                      : field?.id,
                                  value: estimateForm
                                    ? section === "generalInfo"
                                      ? estimateForm[section]?.[row.id] || ""
                                      : section === "services" &&
                                          field?.id === "typeName" &&
                                          estimateForm[section] &&
                                          estimateForm[section][idx]
                                        ? (() => {
                                            const rowData =
                                              estimateForm[section][idx] || {};

                                            const savedTypeName = String(
                                              rowData?.typeName || "",
                                            ).trim();
                                            const rowTypeId = getBaseServiceTypeKey(
                                              rowData?.type || "",
                                            );

                                            if (savedTypeName) {
                                              return savedTypeName;
                                            }

                                            if (rowTypeId) {
                                              const matchedOption = (
                                                field?.options || []
                                              ).find(
                                                (option: any) =>
                                                  getBaseServiceTypeKey(
                                                    option?.type ||
                                                      option?.id ||
                                                      "",
                                                  ) === rowTypeId,
                                              );

                                              if (matchedOption?.name) {
                                                return matchedOption.name;
                                              }
                                            }

                                            const rowTypeName = String(
                                              rowData?.typeName || "",
                                            )
                                              .toLowerCase()
                                              .trim();
                                            const matchedOption = (
                                              field?.options || []
                                            ).find((option: any) => {
                                              const optionLabel = String(
                                                option?.name ||
                                                  option?.label ||
                                                  option ||
                                                  "",
                                              )
                                                .toLowerCase()
                                                .trim();
                                              return optionLabel === rowTypeName;
                                            });

                                            return (
                                              matchedOption?.id ||
                                              rowData?.typeName ||
                                              ""
                                            );
                                          })()
                                        : section === "services" &&
                                            estimateForm[section] &&
                                            estimateForm[section][idx]
                                          ? estimateForm[section][idx][
                                              field.id
                                            ] === 0
                                            ? 0
                                            : estimateForm[section][idx][
                                                field.id
                                              ] || ""
                                          : section &&
                                              estimateForm[section] &&
                                              estimateForm[section][idx]
                                            ? estimateForm[section][idx][field.id]
                                            : estimateForm[field.id]
                                    : "",
                                  variant: "outlined", // Adding this variant prop
                                  isNonMarginTop: true,
                                  ...(field?.type === "select" && {
                                    options: (() => {
                                      if (field?.id === "vehicleTypeId") {
                                        return vehiclesOptions;
                                      }

                                      if (
                                        section === "services" &&
                                        field?.id === "typeName"
                                      ) {
                                        const currentValue =
                                          getServiceNameKey(row) ||
                                          getBaseServiceTypeKey(row?.type || "");
                                        const filteredOptions = field?.options || [];

                                        const hasCurrentOption = filteredOptions.some(
                                          (option: any) =>
                                            getServiceNameKey(option) === currentValue,
                                        );

                                        if (
                                          !hasCurrentOption &&
                                          row?.typeName &&
                                          !(idx > 0 && isRemovalRow(row))
                                        ) {
                                          return [
                                            {
                                              id: row?.typeName,
                                              name: row?.typeName,
                                            },
                                            ...filteredOptions,
                                          ];
                                        }

                                        return filteredOptions;
                                      }

                                      return field?.options || [];
                                    })(),
                                  }),
                                  disabled:
                                    section === "generalInfo" ||
                                    (typeof field?.disabled === "function"
                                      ? field?.disabled({
                                          row,
                                          idx,
                                          section,
                                          estimateForm,
                                          field,
                                        })
                                      : field?.disabled) ||
                                    disabled,
                                  InputProps: {
                                    ...field?.inputProps,
                                    autocomplete: "off",
                                    
                                    sx: {
                                      // ...field?.inputProps?.sx,
                                      padding: "2px 4px",
                                      height: "20px",
                                      ...(section === "services" &&
                                      field?.id === "typeName"
                                        ? { fontSize: "13px" }
                                        : {}),
                                    },
                                  },
                                  onChange: (e: any) =>
                                    onChangeAction(
                                      e,
                                      section,
                                      // section === "generalInfo" ? 0 :
                                      idx,
                                      field?.valueFormat,
                                    ),
                                  onBlur: onBlurAction,
                                  error:
                                    error && section
                                      ? error[section]
                                        ? error[section][idx]
                                        : false
                                      : error?.[field.id],
                                }}
                              />
                            )}
                          </TableCell>
                        );
                      })}
                    {/* Add Delete Icon for the row */}
                    {fields &&
                      fields.length &&
                      fields.map((field: any, fieldIdx: number) => {
                        return (
                          section === "services" &&
                          field?.id === "typeName" &&
                          idx >= 2 && // Ensure it's an extra service row
                          !row?.isAccepted && // Only allow deleting unaccepted rows
                          hideExtraServiceDelete !== false &&
                          // ![
                          //   "Clearance",
                          //   "Into Store",
                          //   "Out Of Store",
                          //   "Removal",
                          //   "Full Pack",
                          //   "Unpack",
                          //   "Dismantle",
                          //   "Fragile Pack",
                          //   "Vehicle Hire",
                          //   "Export Pack",
                          //   "Storage",
                          // ].includes(row?.typeName) && (
                          ![
                            "clearance",
                            "intostore",
                            "outofstore",
                            "removal",
                            "fullpack",
                            "unpack",
                            "dismantle",
                            "fragilepack",
                            "vehiclehire",
                            "exportpack",
                            "storage",
                          ].includes(row?.type?.toLowerCase()) && (
                            <TableCell sx={{ width: "20px" }}>
                              <IconButton
                                sx={{ padding: "0px" }}
                                onClick={() => handleDeleteServiceRow(idx)}
                                color="error"
                                disabled={disabled} // Disable delete button if the row is disabled
                              >
                                <DeleteOutlined />
                              </IconButton>
                            </TableCell>
                          )
                        );
                      })}
                  </TableRow>
                </>
              ))
            : null}
          {additionRow}
        </>
      </TableDesign>
    )
  );
};

export default RenderEstimateTable;
